import {ModelValidator} from '../ModelValidator';
import {FieldModel} from '../../../../view-model/field-model';
import {MultilingualModel} from '../../../../view-model/type/multilingual-model';
import {Severity, ValidationNotification} from '../../../../types/app-types';
import {Language} from '../../../../types/data-model';

/**
 * Checks optional multilingual fields to ensure that either both or neither are filled - if only one is filled, an error is displayed.
 */
export class NonMandatoryMultilingualValidator extends ModelValidator<FieldModel<any>> {
  static readonly MANDATORY_ERROR_MSG =
    'Bitte erfassen Sie einen Wert. Die Beschreibung muss in allen Amtssprachen der Bekanntmachung vorhanden sein.';

  constructor() {
    super();
  }

  validate(fieldModel: MultilingualModel): Promise<ValidationNotification[]> {

    const errors = [];

    if (this.isMultilingualFieldValueMissing(fieldModel)) {
      errors.push(
        new ValidationNotification(
          NonMandatoryMultilingualValidator.MANDATORY_ERROR_MSG,
          Severity.ERROR,
          this.getLanguageOfEmptyField(fieldModel)
        )
      );
    }

    return Promise.resolve(errors);
  }

  shouldAttach(model: FieldModel<any>): boolean {
    return model instanceof MultilingualModel && !model.isMandatory;
  }

  private isMultilingualFieldValueMissing(fieldModel: MultilingualModel): boolean {
    return this.multipleLanguagesSelected(fieldModel)
      && !fieldModel.englishValue != !fieldModel.germanValue;
  }

  private multipleLanguagesSelected(fieldModel: MultilingualModel) : boolean {
    return fieldModel.activeLanguages.length > 1;
  }

  private getLanguageOfEmptyField(fieldModel: MultilingualModel) : Language {
    if(!fieldModel.germanValue) {
      return Language.Deu;
    }

    if(!fieldModel.englishValue) {
      return Language.Eng;
    }

    console.error("Illegal state! Neither german value nor english value is empty.")
    return null;
  }
}
